import moment from 'moment-timezone';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import { showToast } from 'stores/ToastStore';
import i18next from 'i18next';
import ShipmentWebAPIUtils, { updateShipmentTags, } from 'utils/ShipmentWebAPIUtils';
export const onDateCellEdit = (params) => {
    if (params.valueChanged) {
        const dateCheck = moment(params.newValue);
        if (dateCheck.isValid() && params.data && params.colDef) {
            const shipment_id = params.data.shipment_oid;
            const key = params.colDef.schema_value;
            const newDate = new Date(`${params.newValue} 00:00:00`).toISOString();
            if (key) {
                const updates = [
                    {
                        job_id: shipment_id,
                        updates: { [key]: newDate },
                        meta: {},
                    },
                ];
                ShipmentsActionCreators.bulkUpdateDates(updates);
            }
        }
    }
};
export const onUpdatePODStatus = (params) => {
    if (params.valueChanged) {
        const value = params.newValue;
        const shipmentId = params.data.shipment_oid;
        if (shipmentId) {
            ShipmentsActionCreators.updatePODStatus(shipmentId, value);
        }
        else {
            showToast('', 'Update Failed: No Shipment Found', 'error');
        }
    }
};
export const onAdminNotesEdit = (params) => {
    if (params.valueChanged) {
        const value = params.newValue;
        const shipmentId = params.data.shipment_oid;
        if (shipmentId) {
            ShipmentsActionCreators.updateAdminNotesById(shipmentId, value);
        }
        else {
            showToast('Update Failed', 'Update Failed: No Shipment Found', 'error');
        }
    }
};
export const onShipmentCommentAdd = async (message, shipmentId) => {
    const { t } = i18next;
    try {
        const res = await ShipmentWebAPIUtils.addComment(shipmentId, message);
        showToast(t('COMMENT_UPDATED_SUCCESSFULLY'), '', 'success');
        return res.entity.job.comments.find((comment) => comment.message === message);
    }
    catch (e) {
        console.error(e);
        showToast(t('COMMENT_UPDATE_FAILED'), t('COULDNT_UPDATE_COMMENT', { message: e.message }), 'error');
    }
};
export const onShipmentChangeTags = async (data, tags) => {
    try {
        await updateShipmentTags(data.shipment_oid, tags);
        showToast('Tags updated successfully', '', 'success');
    }
    catch (e) {
        console.error(e);
        showToast('Tags update failed', '', 'error');
    }
};
